/**
 * Преобразование строки true в boolean
 */

export const parseBoolean = (str: string): boolean => str.toLowerCase() === 'true'

/**
 * Получение флага по фиче
 */
const getFeatureFlag = (flagName: string): boolean => {
  if (typeof localStorage === 'undefined') {
    return false
  }

  return parseBoolean(localStorage.getItem(flagName) || '')
}

/**
 * Флаг для включения новогоднего логотипа (добавляется новогодняя шапка)
 */

export const newYearLogo = false

/**
 * Отображение инструментов для разработчиков и тестировщиков (быстрый переход на создание заказа гостя, заполнение формы моками)
 */
export const devFeatures = getFeatureFlag('devFeatures')

/**
 * Отображение оформления посылки для неавторизованного пользователя
 */
export const orderYarcheGuestCreate = getFeatureFlag('orderYarcheGuestCreate')

/**
 * Отображение оформления посылки для авторизованного пользователя
 */
export const orderYarcheCreate = getFeatureFlag('orderYarcheCreate')

/**
 * Отображение форму оплаты по qr/карте
 */
export const paymentForm = true

/**
 * Отображение реализации допуслуг для заказа
 */
export const orderOperation = true
